/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
//import "./layout.css"

//import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/materialdesignicons.min.css';
//import './css/line.css';
import '../assets/css/tiny-slider.css';
import '../assets/css/style.css';
import '../assets/css/colors-default.css';

import 'feather-icons/dist/feather.min.js';
//import 'tiny-slider/src/tiny-slider.js';

//import '../assets/js/plugins.init.js';
import AppLoad from '../assets/js/app.js';
import { useEffect } from "react";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  useEffect(() => {
    AppLoad();
  }, []);

  return (
    <>
      <Header/>
          {children}
      <Footer/>
    </>
  );

  /*return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
    <img src="#"></img>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <main>{children}</main>
        <footer
          style={{
            marginTop: `2rem`,
          }}
        >
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.com">Gatsby</a>
        </footer>
      </div>
    </>
  )*/
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
